import Vue from 'vue';
import SiteSelector from '@/modules/site/Selector';
import DatePicker from '@/components/date/DatePicker.vue';
import DateTimePicker from '@/components/date/DateTimePicker.vue';

Vue.component(SiteSelector.name, SiteSelector);
Vue.component(DatePicker.name, DatePicker);
Vue.component(DateTimePicker.name, DateTimePicker);
